/**
 * @author HungNS
 */
import BaseService from "./BaseService";

class AuthService extends BaseService {

    async signIn(data = {}, config = {}) {
        const response = await this.post("/login", data, config, true);
        return response;
    }

    async logout(data = {}, config = {}) {
        await this.post("/logout", data, config);
    }
}

export default AuthService;
